import React, { useEffect, useState } from 'react';
import { DentosHeader } from '../components/DentosHeader';
import { DentosFooter } from '../components/DentosFooter';
import { Clock, Calendar, ChevronRight, ArrowRight, ArrowLeft, ArrowUp } from 'lucide-react';
interface KnowledgeBasePageProps {
  onNavigate: (page: 'home' | 'knowledge' | 'tools' | 'research' | 'dental-kids' | 'logo') => void;
}
interface Article {
  id: number;
  category: string;
  title: string;
  description: string;
  time: string;
  date: string;
  fullText: string;
}
const articles: Article[] = [{
  id: 1,
  category: 'Управление',
  title: 'Я зарабатывал больше когда был врачом. Почему так — и что с этим делать',
  description: 'Почему открытие клиники не всегда означает рост дохода. Три ловушки и пять конкретных шагов.',
  time: '12 мин',
  date: 'Февраль 2026',
  fullText: `Это не жалоба. Это математика.

Вы открыли клинику. Наняли врачей. Взяли на себя аренду, налоги, зарплаты, оборудование, рекламу, административный персонал. И в какой-то момент посчитали — и обнаружили неприятную вещь.

Когда вы просто лечили зубы руками — вы забирали домой больше.

Это не редкость. Это почти правило для владельцев стоматологий которые выросли из врачей.

ЧАСТЬ 1. ПОЧЕМУ ВРАЧ ЗАРАБАТЫВАЕТ БОЛЬШЕ ЧЕМ ВЛАДЕЛЕЦ

Когда вы были врачом — ваша экономика была простой. Пришёл пациент — получили деньги. Вычли налог и аренду рабочего места — осталось ваше. КПД близкий к 100%.

Когда вы стали владельцем — между пациентом и вашим карманом появилась огромная машина расходов которая работает вне зависимости от того сколько пациентов пришло сегодня.

Сравнение:
Врач на найме → Выручка 1 000 000 ₸ → Расходы 200 000 ₸ → Чистыми 800 000 ₸
Владелец клиники → Выручка 5 000 000 ₸ → Расходы 4 200 000 ₸ → Чистыми 800 000 ₸

Выручка выросла в 5 раз. Чистыми — то же самое. А головной боли стало в 10 раз больше.

Ключевая мысль: Проблема не в том что вы стали владельцем. Проблема в том что вы стали владельцем но продолжаете мыслить как врач.

ЧАСТЬ 2. ТРИ ЛОВУШКИ В КОТОРЫЕ ПОПАДАЕТ КАЖДЫЙ

Ловушка 1 — Вы всё ещё стоите у кресла
Вы открыли клинику — но продолжаете лечить пациентов. Потому что так привычно. Потому что жалко терять свой поток. В результате вы одновременно врач и директор. Ни то ни другое не делается хорошо.

Ловушка 2 — Вы не считаете себе зарплату
Большинство владельцев берут деньги из кассы когда нужно — и называют это прибылью. Это не прибыль. Это хаос.
Правильная схема: вы как директор получаете фиксированную зарплату. Всё что остаётся — прибыль бизнеса.

Ловушка 3 — Вы платите за лояльность а не за результат
Хороший человек. Давно работает. Жалко увольнять.
Бизнес платит за результат. Не за стаж.

ЧАСТЬ 3. ПЯТЬ КОНКРЕТНЫХ ШАГОВ

Шаг 1 — Посчитайте реальную себестоимость
Возьмите последние три месяца:
- Общая выручка
- Фонд оплаты труда
- Аренда и коммунальные
- Расходные материалы
- Реклама и маркетинг
- Административные расходы
- Налоги
- Ваша зарплата как директора
Что осталось — реальная прибыль.
Норма: 15-25% чистой прибыли от выручки.
Меньше 10% — система требует пересмотра.

Шаг 2 — Выйдите из кресла
1. Сократите нагрузку до 50% — наймите замену
2. Передайте пациентов с правильным объяснением
3. Освободившееся время — только на управление
4. Через 3-6 месяцев выйдите полностью

Шаг 3 — Введите управленческий учёт
Три отчёта каждый месяц:
- P&L (прибыль и убытки)
- Отчёт по врачам (выручка, пациенты, средний чек)
- Отчёт по пациентам (новые, повторные, no-show, LTV)

Шаг 4 — Привяжите зарплаты к результату
Для врача: выручка с кресла, средний чек, процент принятых планов лечения, повторные визиты.
Для администратора: конверсия звонков, no-show, новые пациенты, NPS.

Шаг 5 — Считайте LTV а не средний чек
Средний чек одного визита: 35 000 ₸
LTV одной семьи за 5 лет: 300 000 — 700 000 ₸
Разница в 10-20 раз.

ЧАСТЬ 4. КОГДА ЖДАТЬ РЕЗУЛЬТАТА

Месяц 1-2: хаос перестройки, просадка на 10-15%
Месяц 3-4: система начинает работать
Месяц 5-6: первая реальная прибыль
Месяц 7-12: рост 20-40% к базовому уровню

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Посчитайте реальную прибыль за последние три месяца. Вычтите все расходы включая рыночную зарплату себе как директору. Что осталось — ваша точка отсчёта.`
}, {
  id: 2,
  category: 'Управление',
  title: 'Мой администратор улыбается пациентам и сливает 40% звонков',
  description: 'Как обнаружить и исправить главную точку потери выручки. С цифрами и системой.',
  time: '10 мин',
  date: 'Февраль 2026',
  fullText: `Она работает в клинике три года. Пациенты её любят. Коллеги с ней ладят. Владелец доволен.
Но когда он впервые подключил запись звонков — картина изменилась.
За один день 23 входящих звонка. Записались 9. Остальные 14 просто ушли. Конверсия — 39%.

Типичный слив — Звонок 1:
Пациент: "Хочу записаться на имплантацию, сколько стоит?"
Администратор: "От 150 000 тенге, зависит от ситуации."
Пациент: "Понятно, спасибо."
Администратор: "Пожалуйста, всего доброго."
Никакого приглашения. Никакой записи.

ПОЧЕМУ ЭТО ПРОИСХОДИТ — 5 ПРИЧИН

1. Не понимают что звонящий уже почти готов.
Человек который позвонил — прошёл долгий путь. Он на 70% уже ваш пациент. Нужно просто довести.

2. Отвечают на вопрос вместо управления разговором.
"Сколько стоит?" — это не запрос на прайс. Это сигнал интереса.

3. Боятся показаться навязчивыми.
Предложить записаться — это не давление. Это сервис.

4. Нет скрипта.
Каждый разговор ведётся по-разному в зависимости от настроения и интуиции.

5. Нет контроля.
Если владелец не слушает звонки — администратор не знает что делает что-то не так.

СКОЛЬКО ЭТО СТОИТ В ДЕНЬГАХ

30 звонков в месяц. Средний чек 15 000 ₸.
Конверсия 40% → записались 12, потеряли 18.
Потери в месяц: 270 000 ₸
Потери в год: 3 240 000 ₸
При LTV 300 000 ₸ — потенциал потерь 32 400 000 ₸ в год.

КАК ИСПРАВИТЬ — 4 ШАГА

Шаг 1 — Подключите запись звонков
Стоит 3 000 — 10 000 ₸ в месяц.
Слушайте минимум 10 звонков в неделю лично.

Шаг 2 — Введите скрипт
Структура: приветствие → выяснение запроса → короткий ответ → предложение двух вариантов времени → фиксация имени и номера → подтверждение.
Ключевое: всегда предлагайте два конкретных времени, не открытый вопрос. Конверсия растёт на 20-30%.

Шаг 3 — Введите KPI
Входящие звонки за неделю → записи → конверсия %.
Цель: минимум 65%, хорошо — 75%+.
Еженедельный 15-минутный разбор звонков вместе.

Шаг 4 — Привяжите бонус к конверсии
Базовый оклад 150 000 ₸ + бонус 30 000 ₸ при конверсии выше 65% + бонус 50 000 ₸ при конверсии выше 75%.

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Подключите запись звонков и прослушайте 10 последних входящих. Посчитайте конверсию. Запишите цифру.
Если меньше 60% — у вас быстрый рост без рекламного бюджета.`
}, {
  id: 3,
  category: 'Управление',
  title: 'Три месяца я не знал что мой врач работает на себя прямо в моей клинике',
  description: 'Как это происходит, какие сигналы нужно замечать и как выстроить систему защиты.',
  time: '9 мин',
  date: 'Февраль 2026',
  fullText: `Врач работает в клинике. Хороший специалист — пациенты его любят, запись плотная. Владелец доволен.
А потом пациенты начинают пропадать. По одному, по два в месяц. Списали на сезонность.
Через три месяца владелец случайно узнаёт: лучший врач принимает тех же пациентов дома. По той же цене. Деньги мимо кассы.

КАК ЭТО РАБОТАЕТ
Врач строит личный контакт с пациентом — это нормально. Пациент привязывается к врачу, доверяет ему.
В какой-то момент врач предлагает: "Я могу принять вас у себя, будет немного дешевле."
Пациент соглашается — ему удобно, врача знает, цена ниже.

РАННИЕ СИГНАЛЫ
- Выручка с кресла растёт медленнее чем поток пациентов
- Врач часто задерживается после смены или приходит раньше
- Пациенты записываются только к нему и если занят — уходят
- Врач активно ведёт личные соцсети со своими контактами
- Мало новых пациентов от его рекомендаций клиники

СИСТЕМА ЗАЩИТЫ

Договор с правильными пунктами:
Запрет на ведение частной практики с пациентами клиники в течение 12 месяцев после увольнения.

Контроль цифр по каждому врачу:
Ежемесячно: пациенты на приёме, выручка, средний чек, повторные визиты именно в клинику.

NPS после каждого визита:
"Оцените визит и порекомендуете ли нашу клинику?" — именно клинику, не врача.

Система лояльности привязанная к клинике:
Бонусные баллы которые теряются при уходе к врачу домой.

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Откройте статистику по каждому врачу за три месяца. Сравните количество пациентов с выручкой. Если соотношение не сходится — начните задавать вопросы.`
}, {
  id: 4,
  category: 'Управление',
  title: 'Я нанял управляющего чтобы освободиться. Стало хуже. Вот где я ошибся',
  description: 'Три главные ошибки при передаче управления и пошаговая система которая реально работает.',
  time: '10 мин',
  date: 'Февраль 2026',
  fullText: `Нанять человека который возьмёт операционку. Чтобы клиника работала без тебя. Мечта каждого владельца который устал.
Многие пробуют. Большинство разочаровываются.
Не потому что управляющие плохие. А потому что передача управления — это не найм человека. Это перестройка всей системы.

ПОЧЕМУ УПРАВЛЯЮЩИЙ НЕ СПАСАЕТ
Владелец нанимает управляющего. Объясняет "как тут всё устроено" за несколько дней. Уходит в сторону.
Через месяц — проблемы. Сотрудники не слушаются нового человека. Решения принимаются медленно. Владелец снова в операционке потому что управляющий постоянно приходит с вопросами.

ТРИ ГЛАВНЫЕ ОШИБКИ

Ошибка 1 — Передали должность но не передали систему.
Управляющий может управлять только тем что описано и измерено. Если нет регламентов, нет метрик, нет KPI — управляющий управляет хаосом.

Ошибка 2 — Не определили зону полномочий.
Что решает сам? Что согласует? Может уволить? Подписать договор? Изменить прайс?
Без письменных границ — либо бездействие, либо конфликт.

Ошибка 3 — Выбрали не того для текущего этапа.
Управляющий который работает в выстроенной системе — не справится с построением системы с нуля.
На старте нужен строитель. В зрелой клинике — операционист.

КАК ПЕРЕДАТЬ УПРАВЛЕНИЕ ПРАВИЛЬНО

Шаг 1 — Опишите все процессы сами (1 месяц)
Как открывается клиника, как обрабатывается звонок, как ведётся пациент от записи до оплаты.

Шаг 2 — Определите 5-7 метрик успеха
Выручка, конверсия администратора, no-show, NPS, текучка.

Шаг 3 — Вводите постепенно
Месяц 1: наблюдает → Месяц 2: берёт отдельные процессы → Месяц 3: полная операционка.

Шаг 4 — Еженедельная встреча 1 на 1
30 минут. Цифры, проблемы, решения. Не больше.

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Напишите список всех решений которые принимаете за неделю. Разделите: "могу делегировать" и "должен решать сам". Это основа для передачи управления.`
}, {
  id: 5,
  category: 'Управление',
  title: 'Почему найм второго врача не удвоил выручку — а создал новые проблемы',
  description: 'Когда второй врач оправдан и что сделать вместо найма чтобы вырасти без лишних расходов.',
  time: '8 мин',
  date: 'Февраль 2026',
  fullText: `Один врач приносит X выручки. Наймём второго — получим 2X. Математика простая. Реальность — другая.
Второй врач почти никогда не удваивает выручку. Зато почти всегда удваивает сложность управления.

ПОЧЕМУ МАТЕМАТИКА НЕ СХОДИТСЯ
Поток пациентов не удваивается автоматически. Новый врач приходит — пациентов на него нет. Первые 2-3 месяца — загрузка 20-30%. Зарплата полная.
Административная нагрузка растёт непропорционально: двойное расписание, конфликты по кабинетам, двойные вопросы по материалам.
Первый врач нервничает — новый воспринимается как конкурент.

КОГДА ВТОРОЙ ВРАЧ ОПРАВДАН
Только при трёх условиях одновременно:
1. Первый врач стабильно загружен 85%+ три месяца подряд
2. Есть реальный поток которому некуда деть — люди не могут записаться в ближайшие две недели
3. Административная система готова к двум врачам

ЧТО ДЕЛАТЬ ВМЕСТО НАЙМА

Оптимизируйте расписание:
15-20% рабочего времени теряется на паузы и неявки. Исправление даёт +15-20% выручки без найма.

Снизьте no-show:
С 15-20% до 5-7% = +10-15% рабочего времени врача.

Увеличьте средний чек:
Полный план лечения вместо лечения по одному зубу = +30-50% к среднему чеку.

Расширьте часы работы:
Вечерние приёмы или суббота — проще и дешевле чем второй врач.

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Посчитайте реальную загрузку врача за последний месяц.
Рабочие часы / часы приёма пациентов.
Если меньше 75% — сначала оптимизируйте.`
}, {
  id: 6,
  category: 'Финансы',
  title: 'Я думал что зарабатываю 2 млн в месяц. Оказалось — 400 тысяч',
  description: 'Анатомия расходов стоматологии и семь скрытых утечек которые есть в большинстве клиник.',
  time: '11 мин',
  date: 'Февраль 2026',
  fullText: `Выручка и прибыль — это не одно и то же.
Большинство владельцев знают выручку. Многие не знают прибыль. Единицы знают куда именно уходят деньги между ними.

АНАТОМИЯ РАСХОДОВ (клиника 3 кресла, выручка 2 млн ₸)
Фонд оплаты труда — 40-50%: 800 000 — 1 000 000 ₸
Аренда — 10-15%: 200 000 — 300 000 ₸
Расходные материалы — 8-12%: 160 000 — 240 000 ₸
Реклама — 5-10%: 100 000 — 200 000 ₸
Административные расходы — 3-5%: 60 000 — 100 000 ₸
Налоги — 3-6%: 60 000 — 120 000 ₸
Итого расходов: 1 380 000 — 1 760 000 ₸
Чистая прибыль: 240 000 — 620 000 ₸
И это без амортизации оборудования и зарплаты владельца.

7 СКРЫТЫХ УТЕЧЕК
1. Материалы без учёта — потери 3-5% выручки
2. Неоплаченные услуги — 1-2% выручки ежемесячно
3. Переплата поставщикам — договоры не пересматриваются годами
4. Раздутый ФОТ — сотрудники работают полный день при неполной загрузке
5. Реклама без аналитики — платят за каналы которые не работают
6. Простой оборудования — загружено на 30-40%, кредит платится полностью
7. Владелец не платит себе зарплату — реальная прибыльность непонятна

КАК НАВЕСТИ ПОРЯДОК

P&L отчёт каждый месяц:
Доходы → расходы по категориям → прибыль.

Норматив на материалы:
Расход на процедуру × количество процедур = плановый расход.
Расхождение больше 10% — разбираться.

Аудит поставщиков раз в полгода:
2-3 альтернативных предложения. 2 часа работы = экономия 15-20% на материалах.

Зарплата владельца — фиксированная статья:
Рыночная стоимость директора клиники вашего масштаба.
Всё что остаётся — реальная прибыль.

Норма здорового бизнеса: 15-25% чистой прибыли.
Меньше 10% — критично.

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Возьмите выписку по счёту за последний месяц.
Разбейте расходы по категориям.
Найдите где доля выше нормы.`
}, {
  id: 7,
  category: 'Финансы',
  title: 'Куда уходят деньги когда кресла заняты а прибыли всё равно нет',
  description: 'Шесть причин почему занятость кресел не равна прибыльности — и как это исправить.',
  time: '9 мин',
  date: 'Февраль 2026',
  fullText: `Расписание заполнено. Врачи работают. Пациенты идут. А в конце месяца смотришь на остаток — и не понимаешь куда ушло.
Занятые кресла и прибыльный бизнес — не одно и то же.

ПАРАДОКС ЗАНЯТОСТИ
Клиника загружена на 90%. Выручка 4 млн в месяц.
Но на каждые 100 ₸ выручки — 95 ₸ расходов.
Прибыль: 5% = 200 000 ₸ с оборота 4 миллиона.
Любой форс-мажор — и клиника уходит в минус.

6 ПРИЧИН ПОЧЕМУ ПРИБЫЛИ НЕТ

1. Низкий средний чек
Кресло занято — но пациенты на дешёвых процедурах: чистки, минимальные пломбы. Время уходит, деньги маленькие.

2. Высокий процент врачам
При 40-50% врачу: с оборота 4 млн → 1.6-2 млн только врачам.
Прибавьте остальные расходы — прибыли почти нет.

3. Дорогая аренда относительно выручки
Если аренда больше 15% выручки — работаете на арендодателя.

4. Неэффективное расписание
Видимая загрузка 90% — реальная продуктивная 60%.
Паузы, административные вопросы, неоптимальные процедуры.

5. Высокий no-show без системы
No-show 20% = каждое пятое кресло пустует.
Снижение до 7% = +16% выручки без новых пациентов.

6. Кредиты и лизинг
Новое оборудование в кредит — платежи съедают прибыль.

КАК ИСПРАВИТЬ

Считайте прибыль с каждого кресла отдельно:
Выручка − зарплата врача − материалы − амортизация.

Введите минимальный дневной показатель:
Минимальная выручка с одного рабочего дня врача.
Ниже нормы — разбирайтесь почему.

Приоритизируйте маржинальные процедуры:
Имплантация, протезирование, эстетика — в приоритет.
Низкомаржинальные — в оставшееся время.

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Посчитайте выручку с каждого кресла отдельно за последний месяц.
Найдите кресло с худшим соотношением загрузка/выручка.
Разберитесь почему.`
}, {
  id: 8,
  category: 'Финансы',
  title: 'Почему скидки убивают клинику медленно — и как я это понял слишком поздно',
  description: 'Математика скидок которую никто не считает. И чем заменить скидки не теряя пациентов.',
  time: '8 мин',
  date: 'Февраль 2026',
  fullText: `Скидка кажется простым решением.
Мало пациентов — скидка. Конкурент демпингует — скидка. Пациент торгуется — скидка.
Каждая отдельная скидка кажется небольшой. В сумме они разрушают экономику клиники.

МАТЕМАТИКА КОТОРУЮ НИКТО НЕ СЧИТАЕТ
Процедура: 50 000 ₸
Себестоимость: 35 000 ₸
Маржа: 15 000 ₸ (30%)

Скидка 10% = 5 000 ₸
Маржа упала с 15 000 до 10 000 ₸ — на треть.
Чтобы компенсировать потерю — нужно на 50% больше процедур.

При системных скидках 10-15%:
Клиника с выручкой 3 млн и маржой 25% → маржа 10-15%.
Разница: 300 000 — 450 000 ₸ прибыли ежемесячно.

ПОЧЕМУ СКИДКИ НЕ РАБОТАЮТ КАК МАРКЕТИНГ
Скидки не строят лояльность. Они строят привычку к скидкам.
Пациент который пришёл из-за скидки — уйдёт к конкуренту который даст больше.
Постоянные скидки сигнализируют: "наши цены завышены."

ЧЕМ ЗАМЕНИТЬ СКИДКИ

Ценность вместо цены:
"Бесплатная консультация при первом визите"
"Гарантия на работу 2 года"
"План лечения без дополнительной оплаты"

Программа лояльности:
Накопительные бонусы, приоритетная запись, специальные условия для семей.

Пакетные предложения:
Пакет процедур по выгодной цене. Пациент чувствует выгоду. Клиника получает гарантированный объём.

Программа рекомендаций:
Скидка не тому кто пришёл — а тому кто привёл.
"Приведи друга — получи бесплатную чистку."

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Посчитайте сколько скидок дано за последний месяц и на какую сумму.
Переведите в потерянную маржу.
Это была инвестиция или просто привычка?`
}, {
  id: 9,
  category: 'Маркетинг',
  title: 'Я потратил 3 млн на рекламу. Пациенты пришли. И ушли. Вот почему',
  description: 'Четыре дыры через которые уходят пациенты — и как их заткнуть до следующего рекламного бюджета.',
  time: '10 мин',
  date: 'Февраль 2026',
  fullText: `Реклама работала. Телефон звонил. Новые пациенты приходили.
А через три месяца стало понятно — они не возвращаются.
Это называется дырявое ведро. Вы наливаете воду — она вытекает снизу.
Можно лить быстрее — но ведро не наполнится пока не заткнуть дыры.

ПОЧЕМУ ПАЦИЕНТЫ НЕ ВОЗВРАЩАЮТСЯ
Пациент пришёл. Его хорошо приняли. Врач сделал работу качественно. Пациент доволен. И больше не вернулся.
Не потому что что-то пошло не так. А потому что клиника не дала ни одной причины вернуться.
Нет напоминания. Нет коммуникации между приёмами. Нет системы которая держит клинику в голове 363 дня в году.

4 ДЫРЫ В ВЕДРЕ

Дыра 1 — Нет следующего шага после визита
Пациент уходит — и это всё. Никакой следующей даты.
Правило: каждый пациент уходит с конкретным следующим шагом.

Дыра 2 — Нет системы напоминаний
Через 6 месяцев нужна плановая чистка.
Клиника не напомнила. Конкурент напомнил — пациент там.
Автоматическое сообщение через 5 месяцев = сервис, не спам.

Дыра 3 — Нет работы с семьёй
Пришла мама — вылечили — ушла.
Никто не предложил записать ребёнка.
Один пациент = потенциально 3-4 человека в семье.

Дыра 4 — Нет сбора отзывов
Довольный молчит. Недовольный пишет.
Репутация формируется теми кому не понравилось.

КАК ЗАТКНУТЬ ДЫРЫ

Шаг 1: Обязательная повторная запись
Администратор не отпускает без следующей даты или согласия на напоминание.

Шаг 2: Автоматические напоминания
Через 5 месяцев: "Добрый день, пора на плановый осмотр. Записаться: [ссылка]"

Шаг 3: Семейные карты
При первом визите: "Есть ли члены семьи которым нужна помощь?"
Конверсия этого вопроса: 20-30%.

Шаг 4: Сбор отзывов
Через день после визита: оценка визита.
Высокая → просьба оставить отзыв на 2ГИС.
Низкая → звонок администратора.

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Посмотрите сколько пациентов пришло впервые три месяца назад.
Сколько из них вернулись хотя бы раз?
Если меньше 40% — ведро течёт.`
}, {
  id: 10,
  category: 'Маркетинг',
  title: 'Мой конкурент не тратит на рекламу ничего — и стоит очередь',
  description: 'Пять вещей которые делает та самая клиника. Как выстроить систему органического роста.',
  time: '9 мин',
  date: 'Февраль 2026',
  fullText: `Соседняя клиника — без таргета, без рекламы, без акций.
А запись на две недели вперёд.
Вы тратите 300 000 ₸ в месяц на рекламу — и едва закрываете расписание. В чём секрет?
Никакого секрета нет. Есть система которая не выглядит как маркетинг.

ТРИ ИСТОЧНИКА ОРГАНИЧЕСКОГО РОСТА
1. Повторные визиты — пациент возвращается по привычке и доверию
2. Рекомендации — пациент приводит семью и друзей
3. Семейный эффект — один пациент превращается в трёх-четырёх

5 ВЕЩЕЙ КОТОРЫЕ ДЕЛАЕТ ТА САМАЯ КЛИНИКА

Первое — Там помнят пациентов
Администратор знает имя. Врач помнит что лечили в прошлый раз.
В карточке: день рождения, имена детей, особенности лечения.
Это ощущение что тебя знают — не купишь рекламой.

Второе — Там всегда есть следующий шаг
"Приходите через полгода на чистку, я вам напомню."
И напоминают. Точно в срок.

Третье — Там работают с детьми как с главными пациентами
Ребёнок который не боится стоматолога = пациент на 20 лет.
И его родители. И его будущие дети.

Четвёртое — Там просят рекомендации правильно
Не "расскажите о нас" — а конкретно:
"Если среди знакомых ищут стоматолога — вот моя визитка."
Конкретная просьба работает в разы лучше намёка.

Пятое — Там дают ценность между визитами
Полезное сообщение раз в месяц. Напоминание о сезонной чистке.
Небольшое — но постоянное присутствие.

КАК ВЫСТРОИТЬ ТАКУЮ СИСТЕМУ
Месяц 1-2: CRM с историей пациента и напоминаниями
Месяц 2-3: администраторы завершают визит следующей записью
Месяц 3-4: система сбора обратной связи и отзывов
Месяц 4-6: семейный подход при каждом визите
Месяц 6-12: рост доли повторных пациентов, первые органические рекомендации

Через год у вас есть то что есть у конкурента. Только вы понимаете как это работает.

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Посчитайте долю повторных пациентов за последний месяц.
Если меньше 50% — органическая система ещё не работает.`
}, {
  id: 11,
  category: 'Детская стоматология',
  title: 'Ребёнок заплакал на кресле — и вся семья ушла навсегда',
  description: 'Разбор одной ошибки которая стоит клинике всей семьи на 15-20 лет. Протокол правильного детского приёма.',
  time: '9 мин',
  date: 'Февраль 2026',
  fullText: `Ребёнок пришёл на приём. Испугался. Заплакал. Врач попытался продолжить. Ребёнок сопротивлялся.
Семья больше не вернулась.
Не потому что врач плохо лечил. А потому что ребёнок ассоциирует эту клинику со страхом. Переубедить его почти невозможно.
Один неудачный детский приём стоит клинике не одного пациента. Он стоит всей семьи на 15-20 лет.

ОТКУДА БЕРЁТСЯ ДЕТСКИЙ СТРАХ
1. Родительский страх — передаётся невербально
2. Рассказы других детей — "там больно"
3. Первый неудачный опыт — закрепляется навсегда
4. Непредсказуемость — неизвестность пугает больше процедуры

ЧТО ДЕЛАЮТ НЕПРАВИЛЬНО

Игнорируют страх:
"Не бойся" — это обесценивание. Признание страха снижает тревогу. Отрицание — усиливает.

Торопятся:
Детский приём требует больше времени. Ребёнок не успевает адаптироваться — возникает сопротивление.

Обманывают:
"Не больно" когда будет немного больно — разрушает доверие навсегда.

Пугают инструментами:
Достать бормашину без предупреждения — гарантированный стресс.

Не работают с родителем:
Тревожная мама передаёт тревогу через язык тела.

ПРОТОКОЛ ПРАВИЛЬНОГО ДЕТСКОГО ПРИЁМА

До визита:
Инструкция родителю: как рассказать ребёнку о визите, каких слов избегать, как настроить позитивно.

Встреча:
Врач встречает по имени. Не торопится. Даёт осмотреться. Разговаривает с ребёнком — не только с мамой.

Знакомство с инструментами — метод "скажи-покажи-сделай":
Объяснить словами → показать на руке → применить.
Бормашина = "жужжалка". Отсос = "пылесосик".

Контроль темпа:
Ребёнок имеет право сказать "стоп". Это не потеря контроля — это построение доверия.

Завершение:
"Ты очень хорошо держал рот открытым. Ты был таким смелым."
Небольшой подарок или стикер.

После визита:
Сообщение родителю с похвалой ребёнка.
Напоминание о следующем визите в игровой форме.

ФИНАНСОВАЯ СТОРОНА
LTV нестрашного детского опыта:
Пациент на 20 лет + родители + будущие дети = 1-2 миллиона тенге для клиники.
LTV плохого детского опыта:
Минус вся семья навсегда.

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Есть ли у вашего детского врача письменный протокол первого приёма? Инструкция для родителей? Специальный язык для работы с детьми?
Если нет — это первое что стоит создать.`
}, {
  id: 12,
  category: 'Законодательство',
  title: 'Меня чуть не сделали частью пенсионной схемы. Рассказываю как это работает',
  description: 'Как работает схема вывода пенсионных накоплений через стоматологии и как защитить свой бизнес.',
  time: '10 мин',
  date: 'Февраль 2026',
  fullText: `Январь 2026. Задержаны 11 человек. 42 стоматологические клиники вовлечены в схему по незаконному выводу пенсионных накоплений. Сумма — 200 миллиардов тенге.
Часть владельцев участвовали осознанно. Другая часть — не знали как именно это работает.

КАК РАБОТАЕТ СХЕМА
Законодательство РК позволяет использовать пенсионные накопления для оплаты медицинских услуг включая стоматологию.
Это легальный механизм.
Мошенническая схема:
Посредник находит клинику. Клиника выставляет счёт за якобы оказанные услуги. Пациент — реальный или фиктивный — подаёт заявку в ЕНПФ. Деньги приходят в клинику. Клиника отдаёт большую часть посреднику наличными.
Услуги при этом либо не оказывались либо в меньшем объёме.

КАК ВТЯГИВАЮТ ВЛАДЕЛЬЦЕВ

Сценарий 1 — "Партнёрство":
"Я приведу пациентов с пенсионными накоплениями."
Поначалу выглядит легально. Потом объём становится подозрительно большим а реальных лечений почти нет.

Сценарий 2 — "Агент":
Берёт на себя всё оформление. "Юридически чисто." Документы фиктивные.

Сценарий 3 — "Оптимизация":
"Оптимизация налогообложения через пенсионные выплаты."
Звучит как легальная схема. На деле — мошенничество.

КРАСНЫЕ ФЛАГИ — ОСТАНОВИТЕСЬ ЕСЛИ:
- Посредник предлагает пациентов "пакетами" — сразу 10-20-50 человек
- Пациенты приходят только для документов, лечение минимальное или отсутствует
- Суммы в документах превышают реально оказанные услуги
- Предлагают наличные расчёты
- Просят подписать документы не читая
- Объясняют: "все так делают" или "абсолютно легально"

КАК ЗАЩИТИТЬ СЕБЯ
Работайте только напрямую с ЕНПФ:
Никаких посредников. Только за реально оказанные услуги.

Документируйте каждую процедуру:
Медкарта + план лечения + согласие пациента + акт работ.

Проверяйте пациентов от посредников:
Реальный пациент = пришёл + осмотрен + получил план + прошёл лечение.

Консультируйтесь с юристом:
Юридическая консультация — 50 000 — 100 000 ₸.
Уголовное дело — несравнимо больше.

Не подписывайте непонятные документы:
Если схема объясняется сложно и непрозрачно — это красный флаг.

ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:
Если работаете с пенсионными накоплениями — проверьте что есть полная документация по каждому случаю.
Если что-то вызывает сомнение — немедленно проконсультируйтесь с юристом.

Эта статья носит информационный характер и не является юридической консультацией.`
}];
const categories = ['Все', 'Управление', 'Финансы', 'Маркетинг', 'Детская стоматология', 'Законодательство'];
// Renders article text with section headers, task blocks, and list items
function ArticleBody({
  text
}: {
  text: string;
}) {
  const lines = text.split('\n');
  const elements: React.ReactNode[] = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (!line.trim()) {
      i++;
      continue;
    }
    // ЗАДАНИЕ block
    if (line.startsWith('ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:')) {
      const taskLines = [line.replace('ЗАДАНИЕ НА ЭТУ НЕДЕЛЮ:', '').trim()];
      i++;
      while (i < lines.length && lines[i].trim()) {
        taskLines.push(lines[i]);
        i++;
      }
      elements.push(<div key={i} className="mt-10 bg-[#F4F6F9] border-l-4 border-[#00C2D4] p-6 rounded-r-xl" data-id="element-478">
          <p className="text-xs font-bold text-[#00C2D4] uppercase tracking-widest mb-3" data-id="element-479">
            Задание на эту неделю
          </p>
          {taskLines.filter(Boolean).map((tl, ti) => <p key={ti} className="text-gray-700 leading-relaxed" data-id="element-480">
              {tl}
            </p>)}
        </div>);
      continue;
    }
    // Section headings: all-caps lines (ЧАСТЬ, КАК, ПОЧЕМУ, ЧТО, КОГДА, СКОЛЬКО, ТРИ, ПЯТЬ, etc.)
    const isHeading = /^[А-ЯЁA-Z0-9\s\.\-—:]+$/.test(line.trim()) && line.trim().length > 3 && !line.startsWith('-');
    if (isHeading) {
      elements.push(<h3 key={i} className="text-base font-bold text-[#0F1E3C] uppercase tracking-wide mt-8 mb-3 pb-2 border-b border-gray-100" data-id="element-481">
          {line.trim()}
        </h3>);
      i++;
      continue;
    }
    // Bullet list items
    if (line.trim().startsWith('- ')) {
      const listItems: string[] = [];
      while (i < lines.length && lines[i].trim().startsWith('- ')) {
        listItems.push(lines[i].trim().slice(2));
        i++;
      }
      elements.push(<ul key={i} className="space-y-2 my-3 ml-1" data-id="element-482">
          {listItems.map((item, li) => <li key={li} className="flex items-start gap-2 text-gray-700 leading-relaxed" data-id="element-483">
              <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#00C2D4] flex-shrink-0" data-id="element-484"></span>
              <span data-id="element-485">{item}</span>
            </li>)}
        </ul>);
      continue;
    }
    // Numbered list items
    if (/^\d+\./.test(line.trim())) {
      const listItems: string[] = [];
      while (i < lines.length && /^\d+\./.test(lines[i].trim())) {
        listItems.push(lines[i].trim().replace(/^\d+\.\s*/, ''));
        i++;
      }
      elements.push(<ol key={i} className="space-y-2 my-3 ml-1" data-id="element-486">
          {listItems.map((item, li) => <li key={li} className="flex items-start gap-3 text-gray-700 leading-relaxed" data-id="element-487">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#00C2D4]/10 text-[#00C2D4] text-xs font-bold flex items-center justify-center mt-0.5" data-id="element-488">
                {li + 1}
              </span>
              <span data-id="element-489">{item}</span>
            </li>)}
        </ol>);
      continue;
    }
    // Regular paragraph
    elements.push(<p key={i} className="text-gray-700 leading-relaxed mb-3" data-id="element-490">
        {line}
      </p>);
    i++;
  }
  return <div data-id="element-491">{elements}</div>;
}
// Sidebar component reused in both views
function Sidebar({
  onArticleClick,
  onNavigate
}: {
  onArticleClick: (id: number) => void;
  onNavigate: (page: any) => void;
}) {
  return <div className="space-y-6" data-id="element-492">
      <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-493">
        <h3 className="text-lg font-bold text-[#0F1E3C] mb-5 flex items-center" data-id="element-494">
          <span className="mr-2" data-id="element-495">🔥</span> Читают сейчас
        </h3>
        <ul className="space-y-4" data-id="element-496">
          {[{
          id: 1,
          title: 'Я зарабатывал больше когда был врачом'
        }, {
          id: 2,
          title: 'Мой администратор сливает 40% звонков'
        }, {
          id: 7,
          title: 'Куда уходят деньги когда кресла заняты'
        }, {
          id: 9,
          title: 'Я потратил 3 млн на рекламу. Пациенты ушли'
        }, {
          id: 11,
          title: 'Ребёнок заплакал — семья ушла навсегда'
        }].map((item, idx) => <li key={idx} className="group cursor-pointer" onClick={() => onArticleClick(item.id)} data-id="element-497">
              <div className="flex items-start gap-3" data-id="element-498">
                <span className="text-gray-300 font-bold text-sm flex-shrink-0" data-id="element-499">
                  0{idx + 1}
                </span>
                <span className="text-sm font-medium text-gray-700 group-hover:text-[#00C2D4] transition-colors leading-snug" data-id="element-500">
                  {item.title}
                </span>
              </div>
            </li>)}
        </ul>
      </div>

      <div className="bg-gradient-to-br from-[#0F1E3C] to-[#00C2D4] p-6 rounded-xl shadow-lg text-white" data-id="element-501">
        <span className="bg-white/10 backdrop-blur-sm px-2 py-1 rounded text-xs font-bold tracking-wider mb-4 inline-block" data-id="element-502">
          DENTAL KIDS
        </span>
        <h3 className="text-lg font-bold mb-4 leading-tight" data-id="element-503">
          Первая клиника в районе которая внедрит это — заберёт рынок
        </h3>
        <div className="space-y-2 mb-5 text-sm text-white/80" data-id="element-504">
          <div className="flex items-center gap-2" data-id="element-505">
            <div className="w-1.5 h-1.5 bg-[#00C2D4] rounded-full" data-id="element-506"></div>
            730 контактов в год
          </div>
          <div className="flex items-center gap-2" data-id="element-507">
            <div className="w-1.5 h-1.5 bg-[#00C2D4] rounded-full" data-id="element-508"></div>
            5-7% no-show
          </div>
          <div className="flex items-center gap-2" data-id="element-509">
            <div className="w-1.5 h-1.5 bg-[#00C2D4] rounded-full" data-id="element-510"></div>
            Запуск за 10 дней
          </div>
        </div>
        <button onClick={() => {
        onNavigate('dental-kids');
        window.scrollTo(0, 0);
      }} className="w-full bg-white text-[#0F1E3C] py-2.5 rounded-lg font-bold text-sm hover:bg-gray-100 transition-colors flex items-center justify-center" data-id="element-511">
          Узнать подробнее <ArrowRight size={15} className="ml-2" data-id="element-512" />
        </button>
      </div>
    </div>;
}
export function KnowledgeBasePage({
  onNavigate
}: KnowledgeBasePageProps) {
  const [activeCategory, setActiveCategory] = useState('Все');
  const [selectedArticle, setSelectedArticle] = useState<Article | null>(null);
  const [visible, setVisible] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const filteredArticles = activeCategory === 'Все' ? articles : articles.filter(a => a.category === activeCategory);
  const openArticle = (article: Article) => {
    setVisible(false);
    setTimeout(() => {
      setSelectedArticle(article);
      setVisible(true);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 200);
  };
  const closeArticle = () => {
    setVisible(false);
    setTimeout(() => {
      setSelectedArticle(null);
      setVisible(true);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 200);
  };
  const handleSidebarArticleClick = (id: number) => {
    const article = articles.find(a => a.id === id);
    if (article) openArticle(article);
  };
  return <div className="min-h-screen font-sans text-slate-800 bg-[#F4F6F9]" data-id="element-513">
      <DentosHeader currentPage="knowledge" onNavigate={onNavigate} data-id="element-514" />

      {/* HERO */}
      <section className="pt-32 pb-14 bg-[#0F1E3C] text-white" data-id="element-515">
        <div className="container mx-auto px-4 md:px-6" data-id="element-516">
          {selectedArticle ?
        // Article breadcrumb hero
        <div data-id="element-517">
              <button onClick={closeArticle} className="flex items-center gap-2 text-[#00C2D4] hover:text-white transition-colors text-sm font-medium mb-6 group" data-id="element-518">
                <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" data-id="element-519" />
                База знаний
              </button>
              <span className="text-[#00C2D4] font-bold tracking-wider uppercase text-xs mb-3 block" data-id="element-520">
                {selectedArticle.category}
              </span>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold mb-5 leading-tight max-w-4xl" data-id="element-521">
                {selectedArticle.title}
              </h1>
              <div className="flex items-center gap-4 text-gray-400 text-sm" data-id="element-522">
                <span className="flex items-center gap-1.5" data-id="element-523">
                  <Clock size={14} data-id="element-524" />
                  {selectedArticle.time} чтения
                </span>
                <span className="flex items-center gap-1.5" data-id="element-525">
                  <Calendar size={14} data-id="element-526" />
                  {selectedArticle.date}
                </span>
              </div>
            </div> :
        // Default hero
        <div data-id="element-527">
              <span className="text-[#00C2D4] font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-528">
                БАЗА ЗНАНИЙ
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight max-w-4xl" data-id="element-529">
                Знания которые работают завтра утром
              </h1>
              <p className="text-xl text-gray-400 max-w-2xl" data-id="element-530">
                Статьи для владельцев стоматологий Казахстана. Без воды — только
                практика.
              </p>
            </div>}
        </div>
      </section>

      {/* CATEGORY FILTER — only on list view */}
      {!selectedArticle && <div className="sticky top-[72px] z-40 bg-white border-b border-gray-200 shadow-sm py-4 overflow-x-auto" data-id="element-531">
          <div className="container mx-auto px-4 md:px-6" data-id="element-532">
            <div className="flex space-x-2 md:space-x-3 min-w-max" data-id="element-533">
              {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-5 py-2 rounded-full text-sm font-bold transition-all duration-300 ${activeCategory === category ? 'bg-[#00C2D4] text-white shadow-md' : 'bg-white text-gray-600 border border-gray-200 hover:border-[#00C2D4] hover:text-[#00C2D4]'}`} data-id="element-534">
                  {category}
                </button>)}
            </div>
          </div>
        </div>}

      {/* MAIN CONTENT */}
      <div className="container mx-auto px-4 md:px-6 py-12 transition-all duration-200" style={{
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0)' : 'translateY(12px)'
    }} data-id="element-535">
        <div className="flex flex-col lg:flex-row gap-10" data-id="element-536">
          {/* LEFT: Article grid OR full article */}
          <div className="lg:w-[68%]" data-id="element-537">
            {selectedArticle ?
          // Full article view
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12" data-id="element-538">
                <p className="text-lg text-gray-500 leading-relaxed mb-8 border-b border-gray-100 pb-8" data-id="element-539">
                  {selectedArticle.description}
                </p>
                <ArticleBody text={selectedArticle.fullText} data-id="element-540" />
                <div className="mt-12 pt-8 border-t border-gray-100 flex items-center justify-between" data-id="element-541">
                  <button onClick={closeArticle} className="flex items-center gap-2 text-[#00C2D4] font-bold hover:gap-3 transition-all group" data-id="element-542">
                    <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" data-id="element-543" />
                    Вернуться к статьям
                  </button>
                  <span className="text-sm text-gray-400" data-id="element-544">
                    {selectedArticle.time} чтения · {selectedArticle.date}
                  </span>
                </div>
              </div> :
          // Article cards grid
          <>
                <div className="grid md:grid-cols-2 gap-5" data-id="element-545">
                  {filteredArticles.map(article => <div key={article.id} onClick={() => openArticle(article)} className="bg-white rounded-xl shadow-sm cursor-pointer flex flex-col border-l-4 border-transparent hover:border-[#00C2D4] hover:shadow-lg hover:-translate-y-1 transition-all duration-300" data-id="element-546">
                      <div className="p-6 flex flex-col h-full" data-id="element-547">
                        <span className="bg-[#F4F6F9] text-[#00C2D4] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide self-start mb-4" data-id="element-548">
                          {article.category}
                        </span>
                        <h3 className="text-lg font-bold text-[#0F1E3C] mb-3 leading-snug flex-grow" data-id="element-549">
                          {article.title}
                        </h3>
                        <p className="text-gray-500 text-sm mb-5 line-clamp-2" data-id="element-550">
                          {article.description}
                        </p>
                        <div className="flex items-center text-xs text-gray-400 font-medium pt-4 border-t border-gray-100" data-id="element-551">
                          <Clock size={13} className="mr-1" data-id="element-552" />
                          <span className="mr-4" data-id="element-553">{article.time}</span>
                          <Calendar size={13} className="mr-1" data-id="element-554" />
                          <span data-id="element-555">{article.date}</span>
                          <span className="ml-auto text-[#00C2D4] flex items-center font-bold" data-id="element-556">
                            Читать <ChevronRight size={14} className="ml-0.5" data-id="element-557" />
                          </span>
                        </div>
                      </div>
                    </div>)}
                </div>
                {filteredArticles.length === 0 && <div className="text-center py-20 bg-white rounded-xl shadow-sm" data-id="element-558">
                    <p className="text-gray-500 text-lg" data-id="element-559">
                      В этой категории пока нет статей.
                    </p>
                    <button onClick={() => setActiveCategory('Все')} className="mt-4 text-[#00C2D4] font-bold hover:underline" data-id="element-560">
                      Показать все статьи
                    </button>
                  </div>}
              </>}
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="lg:w-[32%]" data-id="element-561">
            <div className="sticky top-32" data-id="element-562">
              <Sidebar onArticleClick={handleSidebarArticleClick} onNavigate={onNavigate} data-id="element-563" />
            </div>
          </div>
        </div>
      </div>

      <DentosFooter onNavigate={onNavigate} data-id="element-564" />

      {showScrollTop && <button onClick={() => window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })} className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110" style={{
      background: '#00C2D4'
    }} aria-label="Наверх" data-id="element-565">
          <ArrowUp size={20} color="#fff" data-id="element-566" />
        </button>}
    </div>;
}